export default __webpack_public_path__ + "img/auto.c66b25b8.svg";